import { useEffect, useState } from 'react';

import { loadFromStorage, removeProductView } from '@/utilities/storage';

// The storage only exists in the browser, so the skus are undefined until mounted.
export const useRecentSkus = (currentProductcode = '') => {
  const [skus, setSkus] = useState<string[]>();

  useEffect(() => {
    setSkus(removeProductView(currentProductcode, loadFromStorage()).variant);
  }, [currentProductcode]);

  return skus;
};
